import { useSession } from "../../context/SessionContext";
import { useNavigate } from "react-router-dom";
import { useState } from 'react'
import { THEME_COLOR } from "../../config/club";
const StatusBadge = ({ status }) => {
  const isActive = status === "active";
  return (
    <span
      className="ms-2 d-inline-flex align-items-center gap-1 fw-bold"
      style={{
        fontSize: '0.65rem',
        color: isActive ? "#16c784" : "#dc3545",
        letterSpacing: '0.5px'
      }}
    >
      <span 
        className={`rounded-circle ${isActive ? 'animate-pulse' : ''}`} 
        style={{ 
          width: '6px', 
          height: '6px', 
          backgroundColor: 'currentColor' 
        }} 
      />
      {isActive ? "LIVE" : "ARCHIVED"}
    </span>
  );
};

export default function AdminSessionBar() {
  const { session, sessionId } = useSession();
  const navigate = useNavigate();
    const startDate = session.startAt.toDate(); 
    const endDate = session.endAt.toDate(); 

  if (!sessionId || !session) return null;

  return (
    <div
      className="d-flex justify-content-between align-items-center px-4 py-3 mb-4 shadow-sm"
      style={{
        background: "color-mix(in srgb, var(--card-bg) 80%, transparent)",
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
        border: "1px solid var(--border-color)",
        borderRadius: "20px",
      }}
    >
      <div className="d-flex align-items-center gap-3">
        {/* Visual Icon for Session */}
        <div 
          className="d-none d-sm-flex align-items-center justify-content-center rounded-3"
          style={{ 
            width: '45px', 
            height: '45px', 
            backgroundColor: `${THEME_COLOR}15`, 
            color: THEME_COLOR
          }}
        >
          <i className="bi bi-calendar-event fs-5"></i>
        </div>

        <div>
          <div className="d-flex align-items-center">
            <h5 className="mb-0 fw-bold" style={{ letterSpacing: '-0.5px' }}>
              {session.name}
            </h5>
            <StatusBadge status={session.status} />
          </div>
          <div className="d-flex align-items-center gap-2 mt-1">
            <i className="bi bi-clock text-muted small"></i>
            <span className="text-muted small fw-medium">
              {startDate.toDateString()} {startDate.toLocaleTimeString()} — {endDate.toDateString()} {endDate.toLocaleTimeString()}
            </span>
          </div>
        </div>
      </div>

      <button
        className="btn btn-sm btn-primary rounded-pill px-3 fw-bold d-flex align-items-center gap-2"
        onClick={() => navigate("/admin/select-session")}
      >
        <i className="bi bi-arrow-left-right"></i>
        <span className="d-none d-md-inline">Switch Session</span>
      </button>

      {/* CSS for the pulsing green dot */}
      <style>{`
        @keyframes pulse {
          0% { opacity: 1; transform: scale(1); }
          50% { opacity: 0.5; transform: scale(1.2); }
          100% { opacity: 1; transform: scale(1); }
        }
        .animate-pulse {
          animation: pulse 2s infinite ease-in-out;
        }
      `}</style>
    </div>
  );
}